import React, { useEffect, useState } from 'react';

import Collapse from '@kunukn/react-collapse';
import Content from './Content/';
import LoaderPanel from 'Components/common/LoaderPanel';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import fetchJson from 'Utils/fetchJson';
import { globalTrackerAPIRoot } from 'Constants/locations';

const Detail = (props) => {
  const { showDetail, country, priorityGroups: priorityGroupsSummary } = props;
  const [isFetching, setIsFetching] = useState(false);
  const [priorityGroups, setPriorityGroups] = useState(null);
  const [nationalCounts, setNationalCounts] = useState(null);
  const [vaccinations, setVaccinations] = useState(null);

  useEffect(() => {
    const fetchData = async() => {
      const [
        priorityGroups,
        nationalCounts,
        vaccinations,
      ] = await Promise.all([
        fetchJson(`https://graphics.thomsonreuters.com/data/2021/covid-vaccine-priority-groups-tracker/countries/${country.slug}/data.json`),
        fetchJson(`${globalTrackerAPIRoot}/countries/${country.slug}/counts/all.json`),
        fetchJson(`https://graphics.thomsonreuters.com/data/2020/coronavirus/owid-covid-vaccinations/countries/${country.slug}/data.json`),
      ]);
      setTimeout(() => {
        setPriorityGroups(priorityGroups);
        setNationalCounts(nationalCounts);
        setVaccinations(vaccinations);
        setIsFetching(false);
      }, 0);
    };
    if (showDetail && !priorityGroups && !isFetching) {
      fetchData();
      setIsFetching(true);
    }
  }, [country, showDetail, priorityGroups, isFetching]);

  return (
    <Collapse
      isOpen={showDetail}
    >
      <div className={classnames(component)}>
        {isFetching && (
          <LoaderPanel height={200} />
        )}
        {(priorityGroups && nationalCounts && vaccinations) && (
          <Content
            country={country}
            priorityGroupsSummary={priorityGroupsSummary}
            priorityGroups={priorityGroups}
            nationalCounts={nationalCounts}
            vaccinations={vaccinations}
          />
        )}
      </div>
    </Collapse>
  );
};

export default Detail;
